import { z } from 'zod';

/**
 * WHICH RADIO PLACED A FIELD PUNCH'S FIX, as the device's location API named
 * it (`GeoPick.wireProvider` in the APK).
 *
 * Owner, 2026-10-23: punches at JVC 3 were flagged "Punch 23430m from site
 * centre" — placed in the sea off Palm Jumeirah by NETWORK fixes (Wi-Fi/cell
 * trilateration) claiming 7–200 m. A mobile Wi-Fi router moved between sites
 * keeps its old place in the location database. The server reads a network fix
 * outside the fence as an approximate location, not as a worker elsewhere
 * (`field.punchLocation.ts`).
 *
 * OPTIONAL, so every older APK still validates. NEVER REFUSES: one bad value
 * fails the whole batch, so an unknown word becomes `other` and a blank one
 * absent, rather than an error.
 */
export const FIX_PROVIDERS = ['gps', 'network', 'fused', 'passive', 'other'] as const;
export type FixProvider = (typeof FIX_PROVIDERS)[number];

export const FieldFixProviderSchema = z
  .string()
  .max(64)
  .optional()
  .transform((v): FixProvider | undefined => {
    const s = v?.trim().toLowerCase();
    if (!s) return undefined;
    return (FIX_PROVIDERS as readonly string[]).includes(s) ? (s as FixProvider) : 'other';
  });
